import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { joinChannel } from '../api/client.js';

import { useMyPartyInvalidation } from './useMyPartyInvalidation.js';

import type {
  ChannelId,
  JoinChannelRequest,
  JoinPartyResponse,
  PartySlug,
} from '@mixwire/contracts';

type JoinVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
} & JoinChannelRequest;

export const useJoinChannel = (): UseMutationResult<JoinPartyResponse, Error, JoinVariables> => {
  const invalidateMyParty = useMyPartyInvalidation();

  return useMutation({
    mutationFn: async ({ slug, channelId, displayName }: JoinVariables) =>
      joinChannel(slug, channelId, { displayName }),
    onSuccess: invalidateMyParty,
  });
};
